module.exports = __webpack_public_path__ + "static/media/react.cb1c3272.png";